import { render, staticRenderFns } from "./abnormalRefund.vue?vue&type=template&id=5451a874&scoped=true"
import script from "./abnormalRefund.vue?vue&type=script&lang=js"
export * from "./abnormalRefund.vue?vue&type=script&lang=js"
import style0 from "./abnormalRefund.vue?vue&type=style&index=0&id=5451a874&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5451a874",
  null
  
)

export default component.exports